<template>
	<div class='pagination' v-if='max'>
		<div class='pagination__main'>
			<div class='pagination__item'>
				<a
					@click='changePage(canGoPrev)'
					class='pagination__link pagination__link--prev waves-effect'
					:class='{"is-disabled": !canGoPrev}'
				>
					<svg class='icon'>
						<use xlink:href='#icon-arrow'/>
					</svg>
				</a>
			</div>
			<ul class='pagination__list'>
				<li class='pagination__item' v-if='showPrevDots'>
					<a
						@click='changePage(1)'
						tabindex='0'
						type='button'
						class='pagination__link waves-effect'
						:class='{"is-active": page==1}'
					>
						1
					</a>
				</li>
				<li class='pagination__item' v-if='showPrevDots'>
					<a
						@click='changePage(prevDotsPage)'
						tabindex='0'
						type='button'
						class='pagination__link waves-effect'
					>
						…
					</a>
				</li>
				<li class='pagination__item' v-for='(pg, i) in centerPages' :key='i'>
					<a
						@click='changePage(pg)'
						tabindex='0'
						type='button'
						class='pagination__link waves-effect'
						:class='{"is-active": page==pg}'
					>
						{{pg}}
					</a>
				</li>
				<li class='pagination__item' v-if='showNextDots'>
					<a
						@click='changePage(nextDotsPage)'
						tabindex='0'
						type='button'
						class='pagination__link waves-effect'
					>
						…
					</a>
				</li>
				<li class='pagination__item' v-if='showNextDots'>
					<a
						@click='changePage(max)'
						tabindex='0'
						type='button'
						class='pagination__link waves-effect'
						:class='{"is-active": page==max}'
					>
						{{max}}
					</a>
				</li>
			</ul>
			<div class='pagination__item'>
				<a
					@click='changePage(canGoNext)'
					class='pagination__link pagination__link--next waves-effect'
					:class='{"is-disabled": !canGoNext}'
				>
					<svg class='icon'>
						<use xlink:href='#icon-arrow'/>
					</svg>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import global from '__jsVueMixin/global';
export default {
	mixins:     [global],
	props:  {
		max: {
			type:    Number,
			default: 0
		},
		maxPages: {
			type:    Number,
			default: 9
		},
		routeName: {
			type:    String,
			default: ''
		},
		routeNameFirst: {
			type:    String,
			default: ''
		},
		value: {
			type:    Number,
			default: 1
		}
	},
	mounted() {
		this.model = this.page;
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(newVal) {
				let val = (typeof newVal === 'string') ? (Number(newVal)) : (newVal);
				this.dynamichref = this.changeParam('page', val);
				this.$emit('input', val);
			}
		},
		page() {
			let page = (this.paramsUrlObj.page) ? (this.paramsUrlObj.page) : (1);
			return Number(page);
		},
		showCenterCount() {
			if ((this.max <= this.maxPages - 2)) {
				return this.max;
			}
			return this.maxPages - this.showPrevDots * 2 - this.showNextDots * 2 - 2;
		},
		neegdStartFrom() {
			return this.page - (this.showCenterCount - 1) / 2;
		},
		centerPages() {
			let pages = [];
			if (this.max <= this.maxPages - 2) {
				let neegdStartFrom = 1;
				for (let i = neegdStartFrom; i < this.showCenterCount + neegdStartFrom; i++) {
					pages.push(i);
				}
				return pages;
			}
			if (this.showPrevDots && this.showNextDots) {
				let neegdStartFrom = this.page - (this.showCenterCount - 1) / 2;
				for (let i = neegdStartFrom; i < this.showCenterCount + neegdStartFrom; i++) {
					pages.push(i);
				}
				return pages;
			}
			if (this.showPrevDots) {
				let neegdStartFrom = this.max - (this.showCenterCount - 1);
				for (let i = neegdStartFrom; i < this.showCenterCount + neegdStartFrom; i++) {
					pages.push(i);
				}
				return pages;
			}
			if (this.showNextDots) {
				let neegdStartFrom = 1;
				for (let i = neegdStartFrom; i < this.showCenterCount + neegdStartFrom; i++) {
					pages.push(i);
				}
				return pages;
			}
			return pages;
		},
		showPrevDots() {
			if (this.max <= this.maxPages - 2) {
				return 0;
			}
			if (this.page > this.maxPages / 2) {
				return 1;
			}
			return 0;
		},
		showNextDots() {
			if (this.max <= this.maxPages - 2) {
				return 0;
			}
			if (this.max - this.page > this.maxPages / 2 - 1) {
				return 1;
			}
			return 0;
		},
		prevDotsPage() {
			return this.centerPages[0] - 1;
		},
		nextDotsPage() {
			return this.centerPages[this.centerPages.length - 1] + 1;
		},
		canGoPrev() {
			if (this.page > 1) {
				return this.page - 1;
			}
			return false;
		},
		canGoNext() {
			if (this.page < this.max) {
				return this.page + 1;
			}
			return false;
		},
		paramsUrl() {
			let paramsUrl = '';
			for (const key in this.paramsUrlObj) {
				if (Object.hasOwnProperty.call(this.paramsUrlObj, key)) {
					const element = this.paramsUrlObj[key];
					if (key !== 'page') {
						paramsUrl += `&${key}=${element}`;
					}
				}
			}
			return paramsUrl;
		},
		char() {
			return (this.routeName.indexOf('?') > -1) ? ('&') : ('?');
		}
	},
	methods: {
		changePage(page) {
			this.model = page;
		}
	}
};
</script>
